import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isBlank'
})
export class IsBlankPipe implements PipeTransform {

  transform(value: string | null | undefined): boolean {
    return !value || value.trim() === '';
  }

}
